<template>
    <div
        class="normal-container my-10 flex flex-col items-center justify-center gap-10 border-y-[2px] border-green-200 py-10 lg:flex-row lg:border-y-[3px]"
        v-if="quote">
        <NuxtImg
            v-if="image"
            class="mb-6 h-[156px] w-[102px] rounded-custom-full object-cover lg:mb-0"
            :src="useImageUrl(image).url()"
            :alt="image.imageAlt" />
        <div>
            <div class="relative">
                <h2 class="alt-title relative mb-4 max-w-[872px] pr-[42px] !font-normal lg:mb-0 lg:pr-0">
                    <span
                        class="absolute -left-8 -top-8 font-editorial-new text-[114px] leading-[114px] lg:text-[134px] lg:leading-[134px]">
                        “
                    </span>
                    {{ quote }}
                    <span
                        class="absolute -bottom-px right-0 rotate-180 font-editorial-new text-[114px] leading-[114px] lg:right-auto lg:text-[134px] lg:leading-[134px]"
                        >“
                    </span>
                </h2>
            </div>
            <h3 v-if="name" class="font-mori text-xsm tracking-wide text-green-600 lg:text-base lg:leading-[28px]">
                {{ name }}
            </h3>
        </div>
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps({
        quote: String,
        name: String,
        image: Object,
    });
</script>
<style scoped>
    @reference "tailwindcss";
    .alt-title {
        font-family: 'Editorial New', sans-serif;
        @apply !text-3xl font-light leading-[51px] lg:!text-5xl lg:leading-[80px];
    }
</style>
